import { Checkbox } from "../../Checkbox/index.js";
import React from "react";
import { jsx } from "react/jsx-runtime";
//#region src/TableListColumnFilter/local-components/AllSelectCheckbox.tsx
const resolveItemId = (item, getItemId) => {
	return (getItemId ? getItemId(item) : item.id) ?? "";
};
const AllSelectCheckbox = ({ items, selectedItems, onSelectedItemsChange, getItemId, label = "Все элементы" }) => {
	const visibleItemIds = React.useMemo(() => items.map((item) => resolveItemId(item, getItemId)).filter(Boolean), [getItemId, items]);
	const isAllItemsSelected = React.useMemo(() => {
		if (visibleItemIds.length === 0) return false;
		return visibleItemIds.every((id) => selectedItems[id]);
	}, [selectedItems, visibleItemIds]);
	const isSomeItemsSelected = React.useMemo(() => {
		if (isAllItemsSelected) return false;
		return visibleItemIds.some((id) => selectedItems[id]);
	}, [
		isAllItemsSelected,
		selectedItems,
		visibleItemIds
	]);
	const handleAllItemsClick = () => {
		if (visibleItemIds.length === 0) return;
		if (isAllItemsSelected) {
			onSelectedItemsChange((prev) => {
				const next = { ...prev };
				for (const id of visibleItemIds) delete next[id];
				return next;
			});
			return;
		}
		onSelectedItemsChange((prev) => {
			const next = { ...prev };
			for (const id of visibleItemIds) next[id] = true;
			return next;
		});
	};
	return /* @__PURE__ */ jsx("div", {
		className: "px-2.5 py-2",
		children: /* @__PURE__ */ jsx(Checkbox, {
			className: "max-w-56",
			label,
			checked: isSomeItemsSelected ? "indeterminate" : isAllItemsSelected,
			onChange: handleAllItemsClick,
			disabled: items.length === 0
		})
	});
};
//#endregion
export { AllSelectCheckbox };

//# sourceMappingURL=AllSelectCheckbox.js.map